<template>
  <select v-model="selectedFarm" @change="farmChanged" class="form-control rounded-0 mb-25" :disabled="readonly">
    <option v-for="farm in farms" :value="farm.id" v-bind:key="farm.id">{{ farm.farmShortname }}</option>
  </select>
</template>

<script>
import {onMounted, ref, toRefs, watch} from "vue";
import FarmService from "../services/farmservice";

export default {
  name: "farms",
  props: {
    farm: String,
    season: String,
    readonly: Boolean,
    showAllFarms: Boolean,
    noRoles: Boolean,
    showFullList: Boolean,
    extraFarms: Array,
    excludeFarmTypes: Array
  },
  emit: ["farmChanged"],
  setup(props, {emit}) {
    const farmService = FarmService;
    const {farm, noRoles, showAllFarms, extraFarms, excludeFarmTypes, showFullList} = toRefs(props);

    const selectedFarm = ref();
    const currentSeason = ref();
    const farms = ref([]);

    const farmChanged = async () => {

      selectedFarm.value = farm.value;
    };

    const setupFarms = async () => {
      const periodTotal = await farmService.getCurrentSeason();
      currentSeason.value = periodTotal.seasonID;

      let results;

      if (showFullList != null && showFullList.value) {
        results = await farmService.getAllFarms();
      }
      else if (showAllFarms != null && showAllFarms.value) {
        results = await farmService.getFarms(currentSeason.value, showAllFarms.value);
      }
      //If there are no roles, show all farms across the board
      else if (noRoles != null && noRoles.value) {
        results = await farmService.getFarmsForLookup(currentSeason.value);
      } else {
        results = await farmService.getFarms(currentSeason.value, false);
      }

      results.sort((a, b) => a.farmShortname.localeCompare(b.farmShortname));
      farms.value = [];

      if (extraFarms !== undefined && extraFarms.value != null) {
        extraFarms.value.forEach(farm => {
          farms.value.push({id: farm, farmShortname: farm});
        });
      }

      farms.value.push(...results);

      if (excludeFarmTypes !== undefined && excludeFarmTypes.value != null) {
        farms.value = farms.value.filter(f => !f.farmType || (f.farmType && !excludeFarmTypes.value.some(e => e === f.farmType)));
      }

      selectedFarm.value = farm.value != null ? farm.value : null;

      if (selectedFarm.value != null) {
        emit("farmChanged", selectedFarm.value);
      }
    };

    onMounted(setupFarms);
    watch(farm, farmChanged);
    watch(showAllFarms, async () => {
      await setupFarms();
    });

    return {
      selectedFarm,
      currentSeason,
      farmService: FarmService,
      farms
    };
  },
  methods: {
    farmChanged() {
      this.$emit("farmChanged", this.selectedFarm);
    }
  }
};
</script>